import { render } from "./ToggleEntityArchive.vue?vue&type=template&id=1b6ce3ee&scoped=true&ts=true&lang=pug"
import script from "./ToggleEntityArchive.vue?vue&type=script&lang=ts"
export * from "./ToggleEntityArchive.vue?vue&type=script&lang=ts"

import "./ToggleEntityArchive.vue?vue&type=style&index=0&id=1b6ce3ee&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6ce3ee"]])

export default __exports__